<template>
	<div class="a-flex-rfsc a-ptb-12" >
		<div class="s-search-label a-flex-rfec" v-show="label">
			<span class="a-c-red a-fs-14" v-if="notnull">*</span>
			<span>{{label}}</span>
		</div>
		<el-time-picker
            class="date-range a-ml-10" 
            :class="large?'date-range-large':'date-range'"
            is-range
            v-model="value"
            :value-format='valueFormat'
            :format='valueFormat'
            range-separator="至"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            placeholder="选择时间范围"
            @change="handlerOnPick">
        </el-time-picker>
	</div>
</template>

<script>
	export default {
		props: {
			label: {
				type: String
			},
            minDate: {
				required: false,
				type: String,
                default: '00:00'
			},
			maxDate: {
				required: false,
				type: String,
                default: '23:59'
			},
			startPlaceholder: {
				required: false,
				type: String,
				default: '开始时间'
			},
			endPlaceholder: {
				required: false,
				type: String,
				default: '结束时间'
			},
			/**
			 * 是否必填
			 */
			notnull: {
				type: Boolean,
				default: false,
				required: false,
			},
			/**
			 * 是否为较长的输入框
			 */
			large: {
				type: Boolean,
				required: false,
				default: false
			},
			clearable: {
				type: Boolean,
				default: true
			},
			pickerOptions: {
				require: false
			},
			valueFormat:{
				default: 'HH:mm'
			},
		},
		data() {
			return {
				value: [this.minDate, this.maxDate]
			}
		},
        computed: {
            dateVal () {
                return this.minDate + this.maxDate
            }
        },
        watch: {
            dateVal:{
                handler (val) {
                    if(!val){
                        this.value = []
                    }else {
                        this.value = [this.minDate, this.maxDate]
                    }
                }
            }
        },
		mounted() {
			//this.value1=[this.minDate,this.maxDate]
		},
		methods: {
			handlerOnPick(e) {
                console.log(e,'e');
				this.$emit('update:minDate', e?e[0]:'')
				this.$emit('update:maxDate', e?e[1]:'')
				this.$emit('change', e)
			}
		}
	}
</script>

<style scoped>
	.date-range {
		width: 240px;
	}
	
	.date-range .el-range-input {
		width: 90px;
	}
	
	.date-range-large {
		width: 376px;
	}
	
	.date-range-large .el-range-input {
		width: 108px;
	}

    /deep/ .el-range-separator{
        min-width: 24px !important;
    }

</style>
